<template>
    <HeadlessListbox v-model="currencyValue" v-slot="{ open }" class="relative z-30" as="div">
        <HeadlessListboxButton
            class="py-2 px-4 rounded-full bg-gray-900 text-gray-100 flex items-center h-14"
            as="button"
            :class="$attrs.buttonClass"
        >
            <Icon :name="(selectedCurrency?.icon as string)" class="lg:w-6 lg:h-6 w-5 h-5" />
            <Icon :name="open ? 'tabler:chevron-up' : 'tabler:chevron-down'" size="16px" />
        </HeadlessListboxButton>
        <HeadlessListboxOptions
            class="absolute mt-2 right-0 bg-gray-900 min-w-32 p-2 rounded-2xl flex flex-col space-y-2 z-10"
            as="ul"
        >
            <HeadlessListboxOption
                as="li"
                v-for="(currencyItem, currencyIndex) in currencyItems"
                :key="`currency-item-${currencyIndex}`"
                :value="currencyItem.value"
                :class="selectedCurrency?.title == currencyItem.title ? 'text-brand-300' : 'text-gray-100'"
                class="font-medium transition-all p-2 hover:bg-gray-850 space-x-1 cursor-pointer rounded-lg flex items-center"
            >
                <Icon :name="currencyItem.icon" size="22px" />
                <p class="text-body-lg leading-0">{{ currencyItem.title }}</p>
            </HeadlessListboxOption>
        </HeadlessListboxOptions>
    </HeadlessListbox>
</template>

<script setup lang="ts">
interface ICurrencyItem {
    title: string;
    value: string;
    icon: string;
}

const currencyItems: ICurrencyItem[] = [
    {
        title: "USD",
        value: "usd",
        icon: "mdi:currency-usd",
    },
    {
        title: "GBP",
        value: "gbp",
        icon: "mdi:currency-gbp",
    },
    {
        title: "EUR",
        value: "eur",

        icon: "mdi:currency-eur",
    },
    {
        title: "CAD",
        value: "cad",
        icon: "tabler:currency-dollar-canadian",
    },
];

const currencyValue = defineModel<string>();

const selectedCurrency = ref<ICurrencyItem>();

watch(
    currencyValue,
    () => {
        if (currencyValue.value) {
            selectedCurrency.value = currencyItems.find((x) => x.value === currencyValue.value);
        }
    },
    { immediate: true }
);
</script>
